<template>
	<div>
		<div class="form-group row mb-3">
			<div class="col-lg-4">
				<label for="">Nombre *</label>
				<input type="text" v-model="ProyectoPlano.Nombre" class="form-control" placeholder="Nombre"/>
				<Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
			</div>
			<div class="col-lg-4">
				<label for="">Tipo *</label>
				<select v-model="ProyectoPlano.Tipo" class="form-control">
					<option value="">-Tipo-</option>
					<option value="1">Plano de Sitio</option>
					<option value="2">Plano de Planta</option>
					<option value="3">Plano de Elevación</option>
					<option value="4">Plano de Corte</option>
					<option value="5">Plano de Detalle</option>
					<option value="6">Plano Estructural</option>
					<option value="7">Planos MEP</option>
					<option value="8">Planos de Acabados</option>
					<option value="9">Planos de Taller</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="errorvalidacion.Tipo[0]"></Cvalidation>
			</div>
			<div class="col-lg-4">
				<label>Fecha *</label>
				<v-date-picker v-model="ProyectoPlano.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="col-lg-2">
				<label for="">Revisión</label>
				<select v-model="ProyectoPlano.Revision" class="form-control">
					<option value="">-Revisión-</option>
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
					<option value="5">5</option>
					<option value="6">6</option>
					<option value="7">7</option>
					<option value="8">8</option>
					<option value="9">9</option>
					<option value="10">10</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.Revision" :Mensaje="errorvalidacion.Revision[0]"></Cvalidation>
			</div>
			<div class="col-lg-5">
				<label for="">Dibujó</label>
				<input type="text" v-model="ProyectoPlano.Dibujo" class="form-control" placeholder="Dibujó"/>
				<Cvalidation v-if="this.errorvalidacion.Dibujo" :Mensaje="errorvalidacion.Dibujo[0]"></Cvalidation>
			</div>
			<div class="col-lg-5">
				<label for="">Diseñó</label>
				<input type="text" v-model="ProyectoPlano.Diseno" class="form-control" placeholder="Diseñó"/>
				<Cvalidation v-if="this.errorvalidacion.Diseno" :Mensaje="errorvalidacion.Diseno[0]"></Cvalidation>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="col-lg-6">
				<label>Documento</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="archivo" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="Archivo" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="col-lg-12">
				<label>Comentarios</label>
				<textarea v-model="ProyectoPlano.Comentario" class="form-control" cols="30" rows="4" placeholder="Comentarios"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"ReporteObra",
    props:["poBtnSave","pIdProyecto"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Plano',
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoPlano:{
				IdProyectoPlano:0,
				IdProyecto:0,
				Nombre:'',
				Fecha:'',
				Tipo:'',
				Revision:'',
				Dibujo:'',
				Diseno:'',
				Archivo:'',
				Comentario:'',
			},
			Archivo:'Elegir Archivo (0.5MB)',
			errorvalidacion:[],
		}
	},
	methods: {
		Guardar(){
			let Fecha='';
			if (this.ProyectoPlano.Fecha!='' && this.ProyectoPlano.Fecha!=undefined) {
                let day=this.ProyectoPlano.Fecha.getDate();
                let month=this.ProyectoPlano.Fecha.getMonth()+1;
                let year=this.ProyectoPlano.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let formData=new FormData();
			formData.set('IdProyectoPlano',this.ProyectoPlano.IdProyectoPlano);
			formData.set('IdProyecto',this.ProyectoPlano.IdProyecto);
			formData.set('Nombre',this.ProyectoPlano.Nombre);
			formData.set('Tipo',this.ProyectoPlano.Tipo);
			formData.set('Fecha',Fecha);
			formData.set('Revision',this.ProyectoPlano.Revision);
			formData.set('Dibujo',this.ProyectoPlano.Dibujo);
			formData.set('Diseno',this.ProyectoPlano.Diseno);
			formData.set('Archivo',this.ProyectoPlano.Archivo);
			formData.set('Comentario',this.ProyectoPlano.Comentario);
			let image=this.$refs.archivo.files[0];
			formData.append('ArchivoFile',image);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectoplano/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Plano").modal("hide");
				// this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoPlano={
				IdProyectoPlano:0,
				IdProyecto:0,
				Nombre:'',
				Fecha:new Date(),
				Tipo:'',
				Revision:'',
				Dibujo:'',
				Diseno:'',
				Archivo:'',
				Comentario:'',
			};
			this.Archivo='Elegir Archivo (0.5MB)';
			this.errorvalidacion=[];
		},
		Recuperar(){
			this.$http.get('proyectoplano/recovery',{
                params:{
                    IdProyectoPlano:this.ProyectoPlano.IdProyectoPlano
                }
            }).then((res)=>{
				const objres=res.data.data.proyectoplano;
				this.ProyectoPlano.IdProyectoPlano=objres.IdProyectoPlano;
				this.ProyectoPlano.IdProyecto=objres.IdProyecto;
				this.ProyectoPlano.Nombre=objres.Nombre;
				this.ProyectoPlano.Tipo=objres.Tipo;
				this.ProyectoPlano.Revision=objres.Revision;
				this.ProyectoPlano.Dibujo=objres.Dibujo;
				this.ProyectoPlano.Diseno=objres.Diseno;
				this.ProyectoPlano.Comentario=objres.Comentario;
				this.ProyectoPlano.Archivo=objres.Archivo;
				let formatedDate = objres.Fecha.replace(/-/g, "\/");
				this.ProyectoPlano.Fecha=new Date(formatedDate);
				this.Archivo=objres.Archivo;
			});
		},
		SubirArchivo(){
			const image = this.$refs.archivo.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.archivo;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivo;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoPlano.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoPlano.IdProyectoPlano = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
		// validate(){
		// 	if (this.pListProyectoReporteObra!=undefined) {
		// 		this.ListProyectoReporteObra=this.pListProyectoReporteObra;
		// 	}
		// }
    }
}
</script>

<style>

</style>
